import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { MobileSidebarSideBarAction } from "../../Redux/Action";
import { useNavigate } from "react-router-dom";
function SidebarLeft() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [CheckSidebarForOpen, SetCheckSidebarForOpen] = useState();
  const [verificationSuitOpen, setVerificationSuitOpen] = useState(true);
  const { CheckSidebarOpen, CheckMobileSidebarOpen } = useSelector((state) => {
    return {
      CheckSidebarOpen: state.Header.CheckSidebarOpen,
      CheckMobileSidebarOpen: state.Header.CheckMobileSidebarOpen,
    };
  });
  useEffect(() => {
    SetCheckSidebarForOpen(CheckSidebarOpen);
    // if(CheckSidebarOpen){
    //     return navigate("/Overview"); ///  Payment Gateway
    // }else{
    //     return navigate("/Introduction"); ///  Neo Banking
    // }
  }, [CheckSidebarOpen]);
  useEffect(() => {
    setIsOpen(CheckMobileSidebarOpen);
  }, [CheckMobileSidebarOpen]);

  const scrollToID = (id) => {
    navigate('/verification-suite')
    const element = document.getElementById(id);
    if (element) {
      
        element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <div className="idocs-navigation bg-light">
      <ul className="nav flex-column ">
        <Sidebar breakPoint="lg" toggled={isOpen}>
          {CheckSidebarForOpen == true ? (
            <>
              {/* Payment Gateway Sidebar Start */}
              <Menu>
                <Link to="/Overview">
                  <MenuItem>Overview - Safexpay</MenuItem>
                </Link>
                <Link to="/GetStarted">
                  <SubMenu label="Get Started">
                    <MenuItem> How to Sign In/Sign Up</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/Dashboard">
                  <SubMenu label="Dashboard">
                    <MenuItem  onClick={() => {
                          scrollToID("home-page-pg-sec");
                        }}>Home Page Detail</MenuItem>
                    <MenuItem  onClick={() => {
                          scrollToID("test-live-pg-sec");
                        }}>Test & Live Mode</MenuItem>
                    <MenuItem  onClick={() => {
                          scrollToID("reports-pg-sec");
                        }}>Reports</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/PaymentModesAvailable">
                  <MenuItem>Available Pay Modes</MenuItem>
                </Link>
                <Link to="/Settlements">
                  <SubMenu label="Settlements">
                    <MenuItem onClick={() => {
                          scrollToID("instant-settle-neo-sec");
                        }}> Instant Settlement</MenuItem>
                    <MenuItem onClick={() => {
                          scrollToID("split-settle-neo-sec");
                        }}> Split Settlement </MenuItem>
                    <MenuItem onClick={() => {
                          scrollToID("demand-settle-neo-sec");
                        }}> On Demand Settlement </MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/Refunds">
                  <MenuItem>Refunds</MenuItem>
                </Link>
                <Link to="/PaymentLinks">
                  <MenuItem>Payment Links</MenuItem>
                </Link>
                <Link to="/PaymentButton">
                  <MenuItem>Payment Button</MenuItem>
                </Link>
                <Link to="/Invoices">
                  <MenuItem>Invoices</MenuItem>
                </Link>
                <Link to="/QRCodes">
                  <MenuItem>QR Codes</MenuItem>
                </Link>
                <Link to="/SmartCollect">
                  <MenuItem>Smart Collect</MenuItem>
                </Link>
                <Link to="/RedirectCheckoutPlugins">
                  <SubMenu label="Redirect checkout & Plugins">
                    <MenuItem> Server side integration</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/PaymentIntegration">
                  <SubMenu label="Payment Integration">
                    <MenuItem onClick={() => {
                          scrollToID("aggregator-hosted-pg-sec");
                        }}> Aggregator Hosted (Non-Seamless)</MenuItem>
                    <MenuItem onClick={() => {
                          scrollToID("merchant-hosted-pg-sec");
                        }}> Merchant Hosted (Seamless)</MenuItem>
                    <MenuItem onClick={() => {
                          scrollToID("aggregator-paymode-hosted-sec");
                        }}> Aggregator with Paymode Hosted</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/JSCheckout">
                  <SubMenu label="JS Checkout">
                    <MenuItem>
                      {" "}
                      JS Checkout – Secure and Modern Payment Solution
                    </MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/ECollectAPI">
                  <SubMenu label="E-Collect API">
                    <MenuItem onClick={() => {
                          scrollToID("create-van-pg-sec");
                        }}>Create VAN</MenuItem>
                    <MenuItem onClick={() => {
                          scrollToID("close-van-pg-sec");
                        }}>Close VAN</MenuItem>
                    <MenuItem onClick={() => {
                          scrollToID("fetch-transaction-pg-sec");
                        }}>Fetch Transaction</MenuItem>
                    <MenuItem onClick={() => {
                          scrollToID("fetch-van-list-pg-sec");
                        }}> Fetch VAN list</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/ValidateVPAAPI">
                  <SubMenu label="Validate VPA API">
                    <MenuItem>Validate VPA API</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/StatusAPI">
                  <SubMenu label="Status API">
                    <MenuItem>Status API Integration</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/RefundAPI">
                  <SubMenu label="Refund API">
                    <MenuItem>
                      You can use the Refund API to initiate the refund
                    </MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/ResellerAPI">
                  <SubMenu label="Reseller API">
                    <MenuItem onClick={() => {
                          scrollToID("get-merchant-list-api-sec");
                        }}>GET Merchant List API</MenuItem>
                    <MenuItem onClick={() => {
                          scrollToID("get-transaction-mis-api-sec");
                        }}>GET Transaction MIS API</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/TransactionMIS">
                  <SubMenu label="Transaction MIS">
                    <MenuItem  onClick={() => {
                          scrollToID("login-api-sec");
                        }}>Login API</MenuItem>
                    <MenuItem  onClick={() => {
                          scrollToID("transaction-mis-details-sec");
                        }}>Transaction MIS/ Details Summary</MenuItem>
                    <MenuItem  onClick={() => {
                          scrollToID("get-transaction-details-sec");
                        }}>Get Transaction Detail API</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/SettlementMISAPI">
                  <SubMenu label="Settlement MIS API">
                    <MenuItem onClick={() => {
                          scrollToID("login-api-settle-sec");
                        }}>Login API</MenuItem>
                    <MenuItem onClick={() => {
                          scrollToID("get-settlement-mis-details-sec");
                        }}>Get Settlement MIS Detail API</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/Webhook">
                  <SubMenu label="Webhook">
                    <MenuItem>Webhook response</MenuItem>
                  </SubMenu>
                </Link>
                <Link to="/IntegrationAPIforMerchantOnboarding">
                  <SubMenu label="Integration API for Merchant Onboarding">
                    <MenuItem  onClick={() => {
                          scrollToID("merchant-online-onboard-sec");
                        }}>Merchant Online Onboarding API</MenuItem>
                    <MenuItem  onClick={() => {
                          scrollToID("status-api-sec");
                        }}>Status API</MenuItem>
                    <MenuItem  onClick={() => {
                          scrollToID("document-kyc-upload-sec");
                        }}>Document/KYC Upload API</MenuItem>
                  </SubMenu>
                </Link>
              </Menu>
              {/* Payment Gateway Sidebar End */}
            </>
          ) : CheckSidebarForOpen == "APIX" ? (
            <>
              <Menu>
                <Link to="/Apix">
                  <MenuItem>Introduction</MenuItem>
                </Link>
                
                  <SubMenu
                    label="Verification Suite"
                    open={verificationSuitOpen}
                    onClick={() => {
                      setVerificationSuitOpen(!verificationSuitOpen);
                      scrollToID("verification-suite-api");
                      navigate('/verification-suite')
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        scrollToID("ifsc-validation-sec");
                      }}
                    >
                      IFSC Validation
                    </MenuItem>
                    <SubMenu label="Aadhaar Verification">
                      <MenuItem
                        onClick={() => {
                          scrollToID("validate-aadhar-sec");
                        }}
                      >
                        Aadhaar
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          scrollToID("submit-aadhar-otp-sec");
                        }}
                      >
                        Aadhaar OTP
                      </MenuItem>
                    </SubMenu>
                    <SubMenu label="Bank Verification">
                      <MenuItem
                        onClick={() => {
                          scrollToID("validate-bank-sec");
                        }}
                      >
                        BANK
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          scrollToID("check-status-1");
                        }}
                      >
                        Check Status
                      </MenuItem>
                    </SubMenu>
                    <SubMenu label="OCR">
                      <MenuItem
                        onClick={() => {
                          scrollToID("aadhar-ocr-sec");
                        }}
                      >
                        Aadhaar OCR
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          scrollToID("pan-ocr-sec");
                        }}
                      >
                        PAN OCR
                      </MenuItem>
                    </SubMenu>
                    <SubMenu label="PAN Verification">
                      <MenuItem
                        onClick={() => {
                          scrollToID("pan-validate-sec");
                        }}
                      >
                        PAN
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          scrollToID("check-status-2");
                        }}
                      >
                        Check Status
                      </MenuItem>
                    </SubMenu>
                    <SubMenu label="VPA Verification">
                      <MenuItem
                        onClick={() => {
                          scrollToID("validate-vpa-sec");
                        }}
                      >
                        VPA
                      </MenuItem>
                      <MenuItem
                       onClick={() => {
                        scrollToID("check-status-3");
                      }}
                      >Check Status</MenuItem>
                    </SubMenu>
                  </SubMenu>
                
              </Menu>
            </>
          ) : (
            <>
              {/* Neo Banking Sidebar Start */}
              <Menu>
                <Link to="/Introduction">
                  <MenuItem>Introduction</MenuItem>
                </Link>
                <Link to="/Usecases">
                  <MenuItem>Use Cases</MenuItem>
                </Link>
                <Link to="/FeaturesAndFunctions">
                  <MenuItem>Features And Functions</MenuItem>
                </Link>
                <Link to="/AvailablePayModes">
                  <MenuItem>Available Pay Modes</MenuItem>
                </Link>
                <Link to="/PayoutLifecycleandState">
                  <MenuItem>Payout Lifecycle and State</MenuItem>
                </Link>
                <Link to="/AddFundstoVA">
                  <MenuItem>How to add funds to VA</MenuItem>
                </Link>
                <Link to="/SafexpayPayoutErrorCodes">
                  <MenuItem>Safexpay Payout Error Codes</MenuItem>
                </Link>
                <Link to="/HowtodoPayout">
                  <MenuItem>How to do Payout</MenuItem>
                </Link>
                <Link to="/APIs">
                  <SubMenu label="APIs">
                    <MenuItem  onClick={() => {
                          scrollToID("support-api-sec");
                        }}>Support APIs</MenuItem>
                    <MenuItem  onClick={() => {
                          scrollToID("transaction-flow-sec");
                        }}>Transaction Initiation Flow</MenuItem>
                    {/* <MenuItem>Transaction Initiation Flow 2</MenuItem> */}
                  </SubMenu>
                </Link>
              </Menu>
              {/* Neo Banking Sidebar end */}
            </>
          )}
        </Sidebar>
      </ul>
    </div>
  );
}
export default SidebarLeft;
